<template>
    <div class="head">
        <div class="headTop" v-if="false">
            <div class="headBoxLeft" @click="backHome()">
                <div class="logo"><img :src="logo" alt="" /></div>
                <div>智慧巡检系统后台</div>
            </div>
            <div class="headBoxRight">
                <div class="box userName">{{ userName }}</div>
                <div class="box setPassword" @click="changePassword()">
                    修改密码
                </div>
                <div class="box logOutBtn" @click="logOut()">退出</div>
            </div>
        </div>
        <div class="headLeft">
            <div class="menu">
                <div
                    class="menuSon"
                    v-for="(item, key) in menuData"
                    :key="key"
                    :class="[item.checketFlag ? 'menuChecket' : '']"
                    @click="pageTo(key)"
                >
                    <i :class="[item.showIco]"></i>
                    <span>{{ item.title }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { removeCookie } from "../untils/tools";

export default {
    name: "headView",
    data() {
        return {
            userName: "",
            menuData: [
                {
                    title: "任务看板",
                    checketFlag: false,
                    showIco: "taskSeeIco",
                },
                {
                    title: "部门管理",
                    checketFlag: false,
                    showIco: "departIco ",
                },
                {
                    title: "人员管理",
                    checketFlag: false,
                    showIco: "personIco",
                },
                {
                    title: "点位管理",
                    checketFlag: false,
                    showIco: "pointIco",
                },
                {
                    title: "路线管理",
                    checketFlag: false,
                    showIco: "routerIco",
                },
                {
                    title: "任务管理",
                    checketFlag: false,
                    showIco: "taskIco",
                },
                {
                    title: "巡检记录",
                    checketFlag: false,
                    showIco: "lnspeIco",
                },
                {
                    title: "异常记录",
                    checketFlag: false,
                    showIco: "abnormaIco",
                },
                {
                    title: "故障管理",
                    checketFlag: false,
                    showIco: "faultIco",
                },
                {
                    title: "操作日志",
                    checketFlag: false,
                    showIco: "operationLogIco",
                },
            ],
            logo: "",
        };
    },
    props: {
        showStyle: {
            type: [Number, String],
            default: -2,
        },
    },

    created() {},

    mounted() {
        let token = this.getCookie();
        if (!token && this.$route.name != "Login" && this.$route.name != null) {
            

            const loading = this.$loading({
                lock: true,
                text: "退出登录中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 1)",
            });

            this.$message({
                type: "warning",
                message: "登录过期，请重新登录",
            });

            setTimeout(() => {
                this.$message.closeAll();
                this.$router.replace("/login");

                setTimeout(() => {
                    this.$router.go(0);

                    setTimeout(() => {
                        loading.close()
                    }, 50);
                }, 50);
            }, 1000);
        }

        this.userName = localStorage.getItem("staffNumber");
        this.logo = localStorage.getItem("logo");
        if (this.showStyle != undefined && this.showStyle != -2) {
            this.menuData[Number(this.showStyle) + 1]["checketFlag"] = true;
            this.menuData[Number(this.showStyle) + 1]["showIco"] =
                this.checketIco(this.showStyle);
        }
    },

    methods: {
        logOut() {
            removeCookie();
            this.$router.replace("/login");
        },

        changePassword() {
            this.$router.push({
                path: "/changePassword",
            });
        },

        pageTo(key) {
            // if (key == this.showStyle) return
            switch (key - 1) {
                case 0:
                    this.$router.push("/department");
                    break;
                case 1:
                    this.$router.push("/personnel");
                    break;
                case 2:
                    this.$router.push("/place");
                    break;
                case 3:
                    this.$router.push("/routers");
                    break;
                case 4:
                    this.$router.push("/task");
                    break;
                case 5:
                    this.$router.push("/inspection");
                    break;
                case 6:
                    this.$router.push("/abnormal");
                    break;
                case 7:
                    this.$router.push("/fault");
                    break;
                case 8:
                    this.$router.push("/operationLog");
                    break;
                case -1:
                    this.$router.push("/taskPanel");
                    break;
            }
        },

        backHome() {
            this.$router.push("/");
        },

        goOut() {
            if (!getCookie()) {
                this.$message({
                    type: "warning",
                    message: "登录过期，请重新登录！",
                });
                //
                return setTimeout(() => {
                    this.$message.closeAll();
                    this.$router.replace("/login");
                }, 1000);
            }
            this.getStatisticsInit();
        },

        checketIco(key) {
            switch (key) {
                case 0:
                    return "departIcoNow";
                case 1:
                    return "personIcoNow";
                case 2:
                    return "pointIcoNow";
                case 3:
                    return "routerIcoNow";
                case 4:
                    return "taskIcoNow";
                case 5:
                    return "lnspeIcoNow";
                case 6:
                    return "abnormaIcoNow";
                case 7:
                    return "faultIcoNow";
                case 8:
                    return "operationLogIcoNow"
                default:
                    return "taskSeeIcoNow";
            }
        },
    },
};
</script>

<style lang="less" scoped>
.head {
    position: relative;
    width: 100%;

    .headTop {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 56px;
        color: rgba(25, 137, 250, 1);
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 4px rgba(0, 21, 41, 0.12);
        z-index: 99;

        .headBoxLeft {
            margin-left: 16px;
            display: flex;
            flex-direction: row;
            float: left;
            height: 56px;
            line-height: 56px;
            text-align: left;
            color: rgba(25, 137, 250, 1);
            letter-spacing: 2px;
            font-size: 18px;
            font-weight: 700;
            cursor: pointer;

            .logo {
                padding-left: 15px;
                padding: 5px;
                width: 47px;
                height: 46px;
                color: rgba(25, 137, 250, 1);
                font-size: 12px;
                font-weight: bold;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .headBoxRight {
            margin-top: calc((56px - 32px) / 2);
            display: flex;
            flex-direction: row;
            float: right;
            margin-right: 24px;
            height: 32px;
            line-height: 32px;
            text-align: center;

            .userName {
                margin-right: 25px;
                height: 30px;
                color: rgba(25, 137, 250, 1);
                font-size: 20px;
                width: 102px;
                font-size: 20px;
                font-weight: 400;
            }

            .setPassword {
                margin-right: 15px;
                width: 73px;
                height: 32px;
                background: rgba(103, 194, 58, 1);
                border-radius: 4px;
                color: rgba(255, 255, 255, 1);
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }

            .logOutBtn {
                width: 73px;
                height: 32px;
                color: #fff;
                background-color: rgba(102, 177, 255, 1);
                border-radius: 4px;
                cursor: pointer;
            }
        }
    }

    .headLeft {
        position: absolute;
        left: 0px;
        top: 0;
        width: 210px;
        height: 100vh;
        background: rgba(51, 65, 84, 1);
        mix-blend-mode: normal;
        z-index: 98;
        overflow: hidden;
        .menu {
            margin-top: 56px;

            .menuSon {
                padding: 3px 0;
                display: flex;
                flex-direction: row;
                padding-left: 16px;
                width: 210px;
                height: 56px;
                color: rgba(192, 196, 204, 1);
                font-size: 14px;
                line-height: 56px;
                font-weight: 400;
                cursor: pointer;
                // overflow: hidden;
                i {
                    display: block;
                    margin-top: calc((56px - 24px) / 2);
                    width: 24px;
                    height: 24px;
                }
                span {
                    display: block;
                    padding-right: 10px;
                }

                .departIco {
                    /*部门*/
                    background: url("../assets/headView/departIco.png")
                        no-repeat -20px -19px;
                    background-size: 56px 100px;
                }

                .personIco {
                    /*人员*/
                    background: url("../assets/headView/personIco.png")
                        no-repeat -20px -19px;
                    background-size: 56px 100px;
                }

                .pointIco {
                    /*点位*/
                    background: url("../assets/headView/pointIco.png") no-repeat -20px -19px;
                    background-size: 56px 100px;
                }

                .routerIco {
                    /*路线*/
                    background: url("../assets/headView/routerIco.png")
                        no-repeat -20px -19px;
                    background-size: 56px 100px;
                }

                .taskIco {
                    /*任务*/
                    background: url("../assets/headView/taskIco.png") no-repeat -20px -19px;
                    background-size: 56px 100px;
                }

                .lnspeIco {
                    /*巡检*/
                    background: url("../assets/headView/lnspeIco.png") no-repeat -20px -19px;
                    background-size: 56px 100px;
                }

                .abnormaIco {
                    /*异常*/
                    background: url("../assets/headView/abnormaIco.png")
                        no-repeat -20px -19px;
                    background-size: 56px 100px;
                }

                .faultIco {
                    /*故障*/
                    background: url("../assets/headView/faultIco.png") no-repeat -20px -19px;
                    background-size: 56px 100px;
                }

                .operationLogIco {
                    /*日志*/
                    background: url("../assets/headView/operationLogIco.png") no-repeat -20px -19px;
                    background-size: 56px 100px;
                }

                .taskSeeIco {
                    /*看板*/
                    background: url("../assets/headView/taskSeeIco.png")
                        no-repeat -20px -19px;
                    background-size: 56px 100px;
                }
            }

            .menuSon:hover .departIco {
                background: url("../assets/headView/departIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .departIcoNow {
                background: url("../assets/headView/departIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .menuSon:hover .personIco {
                background: url("../assets/headView/personIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .personIcoNow {
                background: url("../assets/headView/personIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .menuSon:hover .pointIco {
                background: url("../assets/headView/pointIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .pointIcoNow {
                background: url("../assets/headView/pointIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .menuSon:hover .routerIco {
                background: url("../assets/headView/routerIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .routerIcoNow {
                background: url("../assets/headView/routerIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .menuSon:hover .taskIco {
                background: url("../assets/headView/taskIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .taskIcoNow {
                background: url("../assets/headView/taskIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .menuSon:hover .lnspeIco {
                background: url("../assets/headView/lnspeIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .lnspeIcoNow {
                background: url("../assets/headView/lnspeIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .menuSon:hover .abnormaIco {
                background: url("../assets/headView/abnormaIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .abnormaIcoNow {
                background: url("../assets/headView/abnormaIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .menuSon:hover .faultIco {
                background: url("../assets/headView/faultIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .faultIcoNow {
                background: url("../assets/headView/faultIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .menuSon:hover .operationLogIco {
                background: url("../assets/headView/operationLogIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .operationLogIcoNow {
                background: url("../assets/headView/operationLogIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .menuSon:hover .taskSeeIco {
                background: url("../assets/headView/taskSeeIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .taskSeeIcoNow {
                background: url("../assets/headView/taskSeeIco.png") no-repeat -20px -59.5px;
                background-size: 56px 100px;
            }

            .menuSon:hover {
                color: rgba(25, 137, 250, 1);
                background-color: rgba(34, 45, 60, 1);
            }

            .menuChecket {
                color: rgba(25, 137, 250, 1);
                background-color: rgba(34, 45, 60, 1);
            }
        }
    }
}
</style>